import config from 'config';
import { ListPayload, ListResponse, SuccessResponse } from 'core/http/response';
import axiosClient from 'config/axios';
import {
    ApplyItemFieldTemplateRequest,
    DuplicateItemFieldTemplateRequest,
    ItemFieldTemplate,
    ItemFieldTemplateFilters,
    ItemFieldTemplateRequest,
} from './itemFieldTemplate';

export type ListItemFieldTemplateParams = ItemFieldTemplateFilters & {
    page: number;
    size: number;
    query?: string;
    archived: boolean;
};

const TEMPLATES_URL = `${config.declarationsUrl}/item-field-templates`;

export const listItemFieldTemplates = (params: ListItemFieldTemplateParams): Promise<ListPayload<ItemFieldTemplate>> =>
    axiosClient
        .get<ListResponse<ItemFieldTemplate>>(TEMPLATES_URL, { params })
        .then((response) => response.data.payload);

export const getItemFieldTemplate = (templateId: string): Promise<ItemFieldTemplate> =>
    axiosClient
        .get<SuccessResponse<ItemFieldTemplate>>(`${TEMPLATES_URL}/${templateId}`)
        .then((response) => response.data.payload);

export const createItemFieldTemplate = (template: ItemFieldTemplateRequest): Promise<ItemFieldTemplate> =>
    axiosClient
        .post<SuccessResponse<ItemFieldTemplate>>(TEMPLATES_URL, template)
        .then((response) => response.data.payload);

export const updateItemFieldTemplate = (
    templateId: string,
    template: ItemFieldTemplateRequest
): Promise<ItemFieldTemplate> =>
    axiosClient
        .put<SuccessResponse<ItemFieldTemplate>>(`${TEMPLATES_URL}/${templateId}`, template)
        .then((response) => response.data.payload);

export const deleteItemFieldTemplate = (templateId: string): Promise<void> =>
    axiosClient.delete<SuccessResponse<void>>(`${TEMPLATES_URL}/${templateId}`).then(() => undefined);

export const duplicateItemFieldTemplate = (
    templateId: string,
    request: DuplicateItemFieldTemplateRequest
): Promise<ItemFieldTemplate> =>
    axiosClient
        .post<SuccessResponse<ItemFieldTemplate>>(`${TEMPLATES_URL}/${templateId}/duplicate`, request)
        .then((response) => response.data.payload);

export const archiveItemFieldTemplate = (templateId: string): Promise<void> =>
    axiosClient.put<SuccessResponse<void>>(`${TEMPLATES_URL}/${templateId}/archive`).then(() => undefined);

export const unarchiveItemFieldTemplate = (templateId: string): Promise<void> =>
    axiosClient.put<SuccessResponse<void>>(`${TEMPLATES_URL}/${templateId}/unarchive`).then(() => undefined);

export const applyItemFieldTemplate = (
    declarationId: string,
    request: ApplyItemFieldTemplateRequest
): Promise<unknown[]> =>
    axiosClient
        .post<SuccessResponse<unknown[]>>(`${TEMPLATES_URL}/declarations/${declarationId}/apply`, request)
        .then((response) => response.data.payload);
